import { useMagpieTopic } from '../../utils/magpie';
import { isCollaborationSidebarTabType } from '../../utils/typeGuards';
import { RequestChangeStudioCardContext, RequestClearStudioCardContext, CollaborationSidebarStateTopic, CommentNavigationTopic, ReportCardTaskCount, RequestCardTaskCount, RequestChangeSidebarTab, RequestCloseCollaborationSidebar, RequestCreateTask, RequestHighlightModule, RequestOpenCollaborationSidebar, RequestScrollToModule, TasksTopic } from './messages';

/**
 * Sidebar open/close
 */

export const useSidebarMessageHandlers = ({
  onRequestOpenSidebar,
  onRequestCloseSidebar,
  onRequestChangeSidebarTab
}) => {
  useMagpieTopic({
    topic: CollaborationSidebarStateTopic,
    message: RequestOpenCollaborationSidebar,
    onMessage: msg => {
      let tab;
      const payloadTab = msg.payload.tab;
      if (payloadTab && isCollaborationSidebarTabType(payloadTab)) {
        tab = payloadTab;
      }
      onRequestOpenSidebar({
        tab
      });
    }
  });
  useMagpieTopic({
    topic: CollaborationSidebarStateTopic,
    message: RequestCloseCollaborationSidebar,
    onMessage: () => {
      onRequestCloseSidebar();
    }
  });
  useMagpieTopic({
    topic: CollaborationSidebarStateTopic,
    message: RequestChangeSidebarTab,
    onMessage: msg => {
      onRequestChangeSidebarTab({
        tab: msg.payload.tab
      });
    }
  });
};

/**
 * Task Messages
 */

export const useTaskMessaging = ({
  onRequestCreateTask,
  onChangeStudioCardContext,
  onClearStudioCardContext
}) => {
  useMagpieTopic({
    topic: TasksTopic,
    message: RequestCreateTask,
    onMessage: msg => {
      onRequestCreateTask(msg);
    }
  });
  useMagpieTopic({
    topic: TasksTopic,
    message: RequestChangeStudioCardContext,
    onMessage: msg => {
      onChangeStudioCardContext(msg);
    }
  });
  useMagpieTopic({
    topic: TasksTopic,
    message: RequestClearStudioCardContext,
    onMessage: msg => {
      onClearStudioCardContext(msg);
    }
  });
};
export const useCardTaskCountMessaging = ({
  onRequestCardTaskCount,
  onReportCardTaskCount
}) => {
  useMagpieTopic({
    topic: TasksTopic,
    message: RequestCardTaskCount,
    onMessage: onRequestCardTaskCount
  });
  useMagpieTopic({
    topic: TasksTopic,
    message: ReportCardTaskCount,
    onMessage: onReportCardTaskCount
  });
};

/**
 * Deep Commenting messages
 */
export const useDeepCommentingNavigationMessaging = ({
  onRequestScrollToModule,
  onRequestHighlightModule
}) => {
  useMagpieTopic({
    topic: CommentNavigationTopic,
    message: RequestScrollToModule,
    onMessage: msg => {
      onRequestScrollToModule === null || onRequestScrollToModule === void 0 || onRequestScrollToModule(msg);
    }
  });
  useMagpieTopic({
    topic: CommentNavigationTopic,
    message: RequestHighlightModule,
    onMessage: msg => {
      onRequestHighlightModule === null || onRequestHighlightModule === void 0 || onRequestHighlightModule(msg);
    }
  });
};